export default {
  "menu.welcome": "Welcome",
  "menu.more-blocks": "More Blocks",
  "menu.home": "Home",
  "menu.admin": "Admin",
  "menu.admin.sub-page": "Sub-Page",
  "menu.login": "Login",
  "menu.register": "Register",
  "menu.register-result": "Register Result",
  "menu.dashboard": "Dashboard",
  "menu.dashboard.analysis": "Analysis",
  "menu.dashboard.monitor": "Monitor",
  "menu.dashboard.workplace": "Workplace",
  "menu.overview": "Overview",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.form": "Form",
  "menu.form.basic-form": "Basic Form",
  "menu.form.step-form": "Step Form",
  "menu.form.step-form.info": "Step Form(write transfer information)",
  "menu.form.step-form.confirm": "Step Form(confirm transfer information)",
  "menu.form.step-form.result": "Step Form(finished)",
  "menu.form.advanced-form": "Advanced Form",
  "menu.list": "List",
  "menu.list.table-list": "Search Table",
  "menu.list.basic-list": "Basic List",
  "menu.list.card-list": "Card List",
  "menu.list.search-list": "Search List",
  "menu.list.search-list.articles": "Search List(articles)",
  "menu.list.search-list.projects": "Search List(projects)",
  "menu.list.search-list.applications": "Search List(applications)",
  "menu.profile": "Profile",
  "menu.profile.basic": "Basic Profile",
  "menu.profile.advanced": "Advanced Profile",
  "menu.result": "Result",
  "menu.result.success": "Success",
  "menu.result.fail": "Fail",
  "menu.exception": "Exception",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "Trigger",
  "menu.account": "Account",
  "menu.account.center": "Account Center",
  "menu.account.settings": "Account Settings",
  "menu.account.personal_info": "Personal Info",
  "menu.account.personal_info.id": "ID",
  "menu.account.personal_info.operatorName": "Operator Name",
  "menu.account.personal_info.userName": "Login Account",
  "menu.account.personal_info.appid": "AppID",
  "menu.account.personal_info.pid": "Parent",
  "menu.account.personal_info.pid.none": "None",
  "menu.account.personal_info.publicKey": "Public Key",
  "menu.account.personal_info.agentLevel": "Agent Level",
  "menu.account.personal_info.agentLevel.2": "Level 1 Agent",
  "menu.account.personal_info.agentLevel.3": "Level 2 Agent",
  "menu.account.personal_info.agentLevel.4": "Merchant",
  "menu.account.personal_info.agentLevel.unknown": "Unknown",
  "menu.account.personal_info.contactInformation": "Contact",
  "menu.account.personal_info.operatorManagerName": "Manager",
  "menu.account.personal_info.region": "Server Region",
  "menu.account.personal_info.endPoint": "Service Endpoint",
  "menu.account.personal_info.walletMode": "Wallet Mode",
  "menu.account.personal_info.walletMode.single": "Single Wallet",
  "menu.account.personal_info.walletMode.transfer": "Transfer Mode",
  "menu.account.personal_info.status": "Status",
  "menu.account.personal_info.status.normal": "Normal",
  "menu.account.personal_info.status.frozen": "Frozen",
  "menu.account.personal_info.fee": "Fee Rate",
  "menu.account.personal_info.timeZone": "Time Zone",
  "menu.account.personal_info.ipList": "IP Whitelist",
  "menu.account.personal_info.loginIp": "Login IP",
  "menu.account.personal_info.loginTime": "Last Login",
  "menu.account.personal_info.isOpenGoogleCheck": "Google Auth",
  "menu.account.personal_info.bindTime": "Bind Time",
  "menu.account.personal_info.createdAt": "Created At",
  "menu.account.personal_info.updatedAt": "Updated At",
  "menu.account.personal_info.remark": "Remark",
  "menu.account.personal_info.yes": "Yes",
  "menu.account.personal_info.no": "No",
  "menu.account.personal_info.fetchFailed": "Failed to fetch personal info",
  "menu.account.change_password": "Change Password",
  "menu.account.trigger": "Trigger Error",
  "menu.account.logout": "Logout",
  "menu.editor": "Graphic Editor",
  "menu.editor.flow": "Flow Editor",
  "menu.editor.mind": "Mind Editor",
  "menu.editor.koni": "Koni Editor",
  "menu.config": "Configuration",
  "menu.config.currency_config": "Currency Config",
  "menu.config.rtp_config": "RTP Config",
  "menu.config.bet_config": "Bet Tier Config",
  "menu.safe": "Safety Management",
  "menu.safe.warn": "Risk Warning",
  "menu.safe.logs": "Risk Logs",
  "menu.safe.loss_analysis": "Loss Analysis",
  "menu.system": "System Management",
  "menu.system.menu_manage": "Menu Management",
  "menu.system.manager_list": "Manager List",
  "menu.system.role_manage": "Role Management",
  "menu.system.operation_logs": "Operation Logs",
  "menu.system.game_verification": "Game Verification",
  "menu.review_center": "Review Center",
  "menu.review_center.my": "My Requests",
  "menu.review_center.pending": "Pending Review",
  "menu.merchant": "Merchant Management",
  "menu.merchant.merchant_members": "Merchant List",
  "menu.merchant.merchant_users": "User Management",
  "menu.merchant.merchant_apply": "Merchant Apply",
  "menu.merchant.merchant_review": "Merchant Publish Review",
  "menu.merchant.bill_manage": "Bill Management",
  "menu.merchant.merchant_settle": "Manual Settlement",
  "menu.report": "Report Management",
  "menu.report.flow_report": "Flow Report",
  "menu.report.bet_record": "Bet Record",
  "menu.report.agent_report": "Agent Report",
  "menu.user_analysis": "User Analysis",
  "menu.user_analysis.retention": "Retention Analysis",
  "menu.user_analysis.action": "Action Analysis",
  "menu.user_analysis.country_area": "Country Analysis",
  "menu.statics": "Statics Management",
  "menu.statics.buybonus": "Buy Bonus Statics",
  "menu.statics.data_analysis": "Data Analysis",
  "menu.statics.games_analysis": "Game Analysis",
  "menu.statics.hall": "Game Hall Statistics",
  "menu.games": "Game Management",
  "menu.game_static": "Game Static Assets",
  "menu.business": "Activity Management",
  "menu.business.activity_manage": "Activity Management",
  "menu.business.giftspin": "Gift Spin Records",
  "menu.business.whitelist": "User Whitelist",
  "menu.develop": "Develop Config",
  "menu.system.notice_manage": "Notice Management",
  "menu.business.whitelist_record": "Whitelist Bet Records",
};
